import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { OrderModel } from "../models/order.model";
import { DataService } from "../services/data/data.service";

@Injectable({
  providedIn: "root"
})
export class ProducerConsumerOrdersResolverService implements Resolve<OrderModel[]> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OrderModel[]> | Observable<never> {
    const producerId = route.paramMap.get("profileId");
    const consumerId = route.paramMap.get("consumerId");
    return this.dataService.getProducerConsumerOrders(consumerId, producerId).pipe(
      take(1),
      mergeMap(item => {
        if (item) {
          return of(item);
        } else {
          // id not found
          return EMPTY;
        }
      })
    );
  }
}
